import { Box, ColorSwatch, Typography } from '@customink/pigment-react';
import { styled } from '@customink/pigment-react/lib/themeCustomink';

const ColorInfoWrapper = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: '0.25rem',
});

interface GroupItemProductColorInfoProps {
  color: string;
  name: string | undefined;
}

export const GroupItemProductColorInfo = ({
  color,
  name,
}: GroupItemProductColorInfoProps) => (
  <ColorInfoWrapper data-testid="color-info-wrapper">
    <ColorSwatch
      color={color}
      data-testid="color-swatch"
      displayOnly
      sx={{ width: '1.25rem', height: '1.25rem' }}
    />
    <Typography variant="uiTextSmall">{name}</Typography>
  </ColorInfoWrapper>
);
